import { ICluster, ICountryWithCluster, IMarket } from '../models/partnerTerritoryModels'

export class PartnerTerritoryHelper {
  public static sortCountries(value: string[], locationData: any[]): ICountryWithCluster[] {
    let sortedResArr: ICountryWithCluster[] = []
    const selectedCountries = [...value]

    if (selectedCountries.length) {
      const resArr: ICountryWithCluster[] = []
      selectedCountries.forEach((v) => {
        const item = locationData.find((el) => el.name && el.name.toLowerCase() === v.toLowerCase())
        if (item) {
          resArr.push(item)
        }
      })
      sortedResArr = resArr.sort((a, b) => a.name.localeCompare(b.name))
    }
    return sortedResArr
  }
}
